import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { EditLabelComponent } from './edit-label.component';

@NgModule({
  declarations: [EditLabelComponent],
  exports: [EditLabelComponent],
  imports: [
    CommonModule,
    MatInputModule,
    FormsModule
  ]
})
export class EditLabelModule { }
